import { useMutation } from '@tanstack/react-query';
import { updateCityFavorites } from '@/api/city';
import { UpdateCityFavoritesData ,ReturnUpdateDelete} from "@/types";
import { PostParam } from "@/types/index";

export function useUpdateCityFavorites(props?: PostParam) {
  const { onSuccess, onError } = props || {};

  return useMutation<ReturnUpdateDelete, Error, UpdateCityFavoritesData>({
    mutationFn: updateCityFavorites,
    onSuccess,
    onError
  });
}
